import React, { useState, useRef } from 'react';
import { X } from 'lucide-react';
import { cn } from '../../utils/cn';

export function TagInput({ value, defaultValue = [], onChange, placeholder = 'Ajouter…', maxTags, className, disabled }) {
  const [internal, setInternal] = useState(defaultValue);
  const tags = value ?? internal;
  const [draft, setDraft] = useState('');
  const inputRef = useRef(null);

  const setTags = (next) => {
    setInternal(next);
    onChange?.(next);
  };

  const addTag = (raw) => {
    const t = raw.trim();
    if (!t || tags.includes(t)) return;
    if (maxTags && tags.length >= maxTags) return;
    setTags([...tags, t]);
    setDraft('');
  };

  const removeTag = (t) => setTags(tags.filter(x => x !== t));

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addTag(draft);
    } else if (e.key === 'Backspace' && !draft && tags.length) {
      removeTag(tags[tags.length - 1]);
    }
  };

  return (
    <div
      onClick={() => inputRef.current?.focus()}
      className={cn(
        'min-h-10 w-full flex flex-wrap items-center gap-1.5 p-1.5 cursor-text',
        'bg-surface border border-border rounded-md transition-colors duration-fast',
        'focus-within:border-ink focus-within:ring-2 focus-within:ring-ink/15',
        disabled && 'opacity-50 pointer-events-none',
        className,
      )}
    >
      {tags.map((t) => (
        <span key={t} className="inline-flex items-center h-6 px-2 text-xs font-medium bg-ink text-cream rounded gap-1">
          {t}
          <button type="button" onClick={(e) => { e.stopPropagation(); removeTag(t); }} aria-label={`Retirer ${t}`} className="-mr-1 hover:bg-cream/10 rounded-sm p-0.5">
            <X className="w-3 h-3" strokeWidth={2} />
          </button>
        </span>
      ))}
      <input
        ref={inputRef}
        type="text"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={() => addTag(draft)}
        placeholder={tags.length === 0 ? placeholder : ''}
        disabled={disabled}
        className="flex-1 min-w-[80px] h-7 px-1 bg-transparent text-sm outline-none placeholder:text-mute-2"
      />
    </div>
  );
}

export default TagInput;
